import { Component, OnInit, ViewChild, Inject, ViewEncapsulation, Input, AfterViewInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
// import { forkJoin } from 'rxjs/observable/forkJoin';
import { FileProvider } from '../file.provider';
import { forkJoin, Subscription } from 'rxjs';
import { I18N } from 'ess-plugin-base';
import { UIService } from '../../ui.service';
import { FileHandle } from '../../tools/filedrop.directive';
import { Constants } from '../../Constants';
import { StoredFile } from '../../model/file';
import { FileAction, FileDialog } from '../file.list/file.dialog';

export interface UploadData {
    accept: string;
    path: string;
    folder: number;
    resource: string;
    titleText: string;
    files: File[]
}

@Component({
    selector: 'file-upload-dialog',
    templateUrl: './file.upload.dialog.html',
    styleUrls: ['./file.upload.dialog.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class FileUploadDialog implements OnInit, AfterViewInit {

    sublang: Subscription;
    lang: string = "en";
    direction: boolean = true;

    previewDiv: HTMLElement | null;
    // @Input('autoClose')
    // autoClose: boolean = true;

    @ViewChild('file', { static: true })
    file;



    // @Input('folder')
    // folder: number;

    public files: Set<any> = new Set();

    constructor(
        private dialog: MatDialog,
        @Optional() public dialogRef: MatDialogRef<FileUploadDialog>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: UploadData,
        public fileProvider: FileProvider, private ui: UIService, public i18n: I18N) {
    }

    ngOnInit() {
        this.sublang = this.i18n.observeLanguage().subscribe({
            next: (lang) => {
                this.lang = lang;
                this.direction = this.lang == 'ar';
            }
        });
        this.lang = I18N.lang;
        this.direction = this.lang == 'ar';

        if (this.data.titleText && this.data.titleText.length) {
            // this.data.titleText = this.i18n.get('file_dialog_title', this.data.titleText);
        } else {
            this.data.titleText = this.i18n.get('file_dialog_title', 'Upload Files');
        }

        this.primaryButtonText = this.i18n.get('file_upload', 'Upload');

        if (this.data.files) {
            for (let file of this.data.files) {
                //         if (Constants.max_file_size > 0) {
                //             const maxSizeInBytes = Constants.max_file_size * 1024 * 1024; //  MB in bytes
                //             if (file.size <= maxSizeInBytes) {
                //                 this.files.add(file);
                //             } else {
                //                 this.ui.error("Please Select File With Size Less Than or Equal " + Constants.max_file_size + "MB.");
                //             }
                //         } else {
                //             this.files.add(file);
                //         }
                this.files.add(file);
            }
        }
    }

    ngAfterViewInit() {
        // Get a reference to the preview div after the view has been initialized
        this.previewDiv = document.getElementById('preview');
    }


    progress;
    allResults: any[] = [];

    canBeClosed = true;
    primaryButtonText: string;
    showCancelButton = true;
    uploading = false;
    uploadSuccessful = false;

    onFilesAdded() {
        const files: { [key: string]: File } = this.file.nativeElement.files;
        for (let key in files) {
            if (!isNaN(parseInt(key))) {
                if (Constants.max_file_size > 0) {
                    const maxSizeInBytes = Constants.max_file_size * 1024 * 1024;
                    if (files[key].size <= maxSizeInBytes) {
                        debugger;
                        files[key]['isDirectory'] = function () { return false };
                        this.files.add(files[key]);
                    } else {
                        this.ui.error("Please Select File With Size Less Than or Equal " + Constants.max_file_size + "MB.");
                    }
                } else {
                    debugger;
                    files[key]['isDirectory'] = function () { return false };
                    this.files.add(files[key]);
                }
            }
        }
    }

    addFiles() {
        debugger;
        this.file.nativeElement.click();
    }

    // Both close the dialog if done and upload if not done..
    async takeAction() {
        debugger;
        // if everything was uploaded already, just close the dialog
        if (this.uploadSuccessful) {
            return this.dialogRef.close(this.allResults);
        }

        // Stoped By Zidan 24-11-2025 04:24 PM

        // else {
        //     this.ui.error(this.i18n.get('file_dialog_error_upload', 'Error uploading File..'))
        // }

        if (this.files.size == 0) return;

        // set the component state to "uploading"
        this.uploading = true;

        this.data.folder = await this.fileProvider.newFolder(null, this.data.path, this.data.resource);

        // start the upload and save the progress map
        this.progress = this.fileProvider.upload(this.files, this.data.path, this.data.folder, this.data.resource);   //this.data.path, this.data.resource);
        // console.log(this.progress);
        for (const key in this.progress) {
            this.progress[key].progress.subscribe(val => { });     // console.log(val));
        }

        // convert the progress map into an array
        let allProgressObservables = [];
        for (let key in this.progress) {
            allProgressObservables.push(this.progress[key].progress);
        }

        // Adjust the state variables

        // The OK-button should have the text "Finish" now
        this.primaryButtonText = this.i18n.get('file_dialog_finish', 'Finish');

        // The dialog should not be closed while uploading
        this.canBeClosed = false;
        this.dialogRef.disableClose = true;

        // Hide the cancel-button
        //   this.showCancelButton = false;

        // When all progress-observables are completed...
        forkJoin(allProgressObservables)
            .subscribe({
                complete: () => {

                    // ... the dialog can be closed again...
                    this.canBeClosed = true;
                    this.dialogRef.disableClose = false;

                    // ... the upload was successful...
                    this.uploadSuccessful = true;

                    // ... and the component is no longer uploading
                    this.uploading = false;

                    for (const key in this.progress) {
                        this.allResults.push(this.progress[key].result);
                    }
                    this.done();

                },
                error: (err) => {
                    console.log("Error during upload", err);

                    this.canBeClosed = true;
                    this.dialogRef.disableClose = false;

                    // ... the upload was successful...
                    this.uploadSuccessful = false;

                    // ... and the component is no longer uploading
                    this.uploading = false;

                    this.ui.error(this.i18n.get('file_dialog_error_upload', 'Error uploading File..'))
                }
            });
    }

    done() {
        this.dialogRef.close(this.allResults);
    }

    cancel() {
        debugger;
        console.debug('Upload cancelling');
        if (this.uploading) {
            for (let key of Object.keys(this.progress)) {
                if (this.progress[key].progress) {
                    this.progress[key].progress.source.next(0);
                    this.progress[key].progress.source.error();
                }
            }

            //   for(let file of this.file) {
            //       this.fileProvider.cancelUpload(file);
            //   }
            console.debug('Upload unsubscribed');
            this.progress = {};

            this.uploading = false;
            this.uploadSuccessful = false;

            this.canBeClosed = true;
            this.dialogRef.disableClose = false;

            console.debug('Upload dialog closing');
            this.dialogRef.close([]);
        } else {
            this.dialogRef.close([]);
        }
    }

    dropFiles(event: FileHandle[]) {
        debugger;
        for (let handle of event) {
            let exists: boolean = null;
            for (let file of this.files) {
                if (file.name == handle.file.name) {
                    exists = true;
                    break;
                }
            }
            if (!exists) {
                if (Constants.max_file_size > 0) {
                    const maxSizeInBytes = Constants.max_file_size * 1024 * 1024; //  MB in bytes
                    if (handle.file.size <= maxSizeInBytes) {
                        this.files.add(handle.file);
                    } else {
                        this.ui.error("Please Select File With Size Less Than or Equal " + Constants.max_file_size + "MB.");
                    }
                } else {
                    this.files.add(handle.file);
                }
            }
        }
    }

    /*Nobel 2025-08-20*/

    mimeTypeMap: Record<string, string> = {
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'jpe': 'image/jpeg',
        'jfif': 'image/jpeg',
        'png': 'image/png',
        'gif': 'image/gif',
        'webp': 'image/webp',
        'svg': 'image/svg+xml',
        'bmp': 'image/bmp',
        'tiff': 'image/tiff',
        'tif': 'image/tiff',
        'ico': 'image/x-icon'
    };

    previewFile(filex: File | StoredFile) {
        debugger
        if (filex instanceof File) {
            this.previewTrueFile(filex);
            return;
        }
        if (!this.previewDiv) {
            console.error('Preview div not found!');
            return;
        }

        const fFile = filex as StoredFile;
        const previewDiv = this.previewDiv;

        previewDiv.innerHTML = '';
        const fileName = filex.filename
        const fileType = this.mimeTypeMap[fileName.split('.').pop().toLowerCase()];

        this.fileProvider.downloadBlob(filex).then((file: Blob) => {
            debugger;

            const reader = new FileReader();
            let _file: Blob;

            if (fileName.endsWith('.pdf')) {
                _file = new Blob([file], { type: 'application/pdf' });
            } else if (fileType && fileType.startsWith('image/')) {
                _file = new Blob([file], { type: fileType });
            } else {
                previewDiv.innerText = 'File type not supported for preview.';
                return;
            }
            reader.onload = () => {
                const dataUrl = reader.result as string;
                if (fileName.endsWith('.pdf')) {
                    const iframe = document.createElement('iframe');
                    iframe.src = dataUrl;
                    iframe.style.width = '100%';
                    iframe.style.height = '100%';
                    iframe.style.border = 'none';
                    previewDiv.appendChild(iframe);
                } else if (fileType && fileType.startsWith('image/')) {
                    const img = document.createElement('img');
                    img.src = dataUrl;
                    img.style.maxWidth = '100%';
                    img.style.maxHeight = '100%';
                    img.style.objectFit = 'contain';
                    previewDiv.appendChild(img);
                }
            };
            reader.readAsDataURL(_file);
        });
    }


    previewTrueFile(file: File) {
        debugger
        if (!this.previewDiv) {
            console.error('Preview div not found!');
            return;
        }

        this.previewDiv.innerHTML = '';
        const fileName = file.name.toLowerCase();
        const reader = new FileReader();
        if (fileName.endsWith('.pdf')) {
            reader.onload = () => {
                const data = reader.result as string;
                const iframe = document.createElement('iframe');
                iframe.src = data
                iframe.style.width = '100%';
                iframe.style.height = '100%';
                iframe.style.border = 'none';
                this.previewDiv.appendChild(iframe);
            };
            reader.readAsDataURL(file);
        } else if (file.type.startsWith('image/')) {
            reader.onload = () => {
                const data = reader.result as string;
                const img = document.createElement('img');
                img.src = data;
                img.style.maxWidth = '100%';
                img.style.maxHeight = '100%';
                img.style.objectFit = 'contain';
                this.previewDiv.appendChild(img);
            };
            reader.readAsDataURL(file);
        } else {
            this.previewDiv.innerText = 'File type not supported for preview.';
        }
    }

    edit(filex: File | StoredFile) {
        debugger;
        let file: StoredFile = filex as StoredFile;
        if (filex instanceof File) {
            (filex as any).filename = filex.name;
            //version: number;
            //path: string;
            (filex as any).guid = this.randomUUID();
            //lastmodified: number;
            (filex as any).is_dir = false;
            (filex as any).id = 0;
            (filex as any).infolder = 0;
            (filex as any).isDirectory = () => { return false };
        }
        let action = (file.isDirectory()) ? FileAction.RENAME_FOLDER : FileAction.RENAME_FILE;
        let title = 'file.rename_file';
        if (file.isDirectory()) title = 'file.rename_folder';
        if (!file.filename || !file.filename.length) {
            action = FileAction.NEW_FOLDER;
            title = 'file.new_folder';
        }

        this.touch(file, action, title)
    }

    /*Nobel 2025-08-24*/
    delete(filex: File | StoredFile) {
        debugger;
        let file: StoredFile = filex as StoredFile;
        if (filex instanceof File) {
            (filex as any).filename = filex.name;
            //version: number;
            //path: string;
            (filex as any).guid = this.randomUUID();
            //lastmodified: number;
            (filex as any).is_dir = false;
            (filex as any).id = 0;
            (filex as any).infolder = 0;
            (filex as any).isDirectory = () => { return false };
        }
        let action = (file.isDirectory()) ? FileAction.DELETE_FOLDER : FileAction.DELETE_FILE;
        let title = (file.isDirectory()) ? 'file.delete_folder' : 'file.delete_file';
        this.touch(file, action, title);
    }

    touch(file: StoredFile | File, action: FileAction, title: String) {
        debugger;
        // console.log("Editing", file);
        if (!file || !(file as StoredFile).guid) {
            return;
        }


        let filename: string = (file as StoredFile).filename || (file as File).name;
        let extension: string = '';
        const lastDotIndex = filename.lastIndexOf('.');
        if (lastDotIndex > -1 && lastDotIndex != 0) {
            extension = filename.substring(lastDotIndex + 1);
            filename = filename.substring(0, lastDotIndex);
        }

        const dialogRef = this.dialog.open(FileDialog, {
            width: '50%', height: 'auto',
            data: { path: (file as StoredFile).path, name: filename, guid: (file as StoredFile).guid, title: title, action: action }
        });

        dialogRef.afterClosed().subscribe(result => {
            // console.log("dialog returned " + result);
            debugger;
            if (result && result == '__DELETE__') {
                if (this.files != null && this.files.size > 0) {
                    const found: boolean = this.files.has(file);
                    if (found == true) {
                        this.files.delete(file);
                    }
                }
                if (file instanceof StoredFile) {
                    this.fileProvider.delete((file as StoredFile).isDirectory() ? 'folder' : 'file', (file as StoredFile).guid, (file as StoredFile).filename, this.data.resource, (file as StoredFile).infolder || this.data.folder)
                        .then(ok => {
                        })
                        .catch(err => {
                            this.ui.error(this.i18n.get('file_dialog_error_delete', 'Error deleting this item.'))
                        })
                }
            }
            else
                if (result && result != '') {
                    /*Nobel 2025-08-24*/
                    (file as StoredFile).filename = result + '.' + extension;
                    // console.log(result);
                    // if (result.contains('/')) {
                    //     result = result.substring(result.lastIndexOf('/') + 1);
                    // }
                    if (file instanceof StoredFile) {
                        this.fileProvider.rename((file as StoredFile).isDirectory() ? 'folder' : 'file', (file as StoredFile).guid, (file as StoredFile).filename, result, this.data.resource, (file as StoredFile).infolder || this.data.folder)
                            .then(ok => {
                                if (ok) {
                                }
                            })
                            .catch(err => {
                                this.ui.error(this.i18n.get('file_dialog_error_rename', 'Error renaming this item.'))
                            });
                    }
                }
        });
    }

    randomUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

}